var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(-1068 -42)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1068 42)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M18.709,17.289,23,13a1,1,0,0,0-1.421-1.421l-4.287,4.287L13,11.581A1,1,0,1,0,11.581,13l4.287,4.287-4.287,4.287A1,1,0,1,0,13,23l4.287-4.287L21.575,23A1,1,0,1,0,23,21.576Z",
    transform: "translate(1068.215 43.211)",
    fill: "#6e6e6e",
    stroke: "#f5f5f5",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.fe7f7135d7b397c961a3dcb57d784cb5.svg";
export { ForwardRef as ReactComponent };